import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { ElementHeightDirective } from '@df/dom/element-height/element-height.directive';
import { ImageModule } from '@df/module-image/image.module';
import { HrefComponent } from '@df/ui/common/href/href.component';
import { ToggleModule } from '@df/ui/toggle/toggle.module';
import { ToggleService } from '@df/ui/toggle/toggle.service';
import { UiComponent } from '@df/ui/ui.component';
import { ICmsClientModule } from '@icms/client/icms-client.module';
import { GtmTrackNavigationClickDirective } from '../../module/gtm/gtm-track-navigation-click.directive';
import { NPageHeader } from '../page/header/page-header.interface';
/**
 * Meganav content.
 *
 * @usage
 * ```html
 * <meganav-content></meganav-content>
 * ```
 */
@Component({
    selector: 'meganav-content',
    templateUrl: 'meganav-content.html',
    styleUrls: ['./meganav-content.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [
        ElementHeightDirective,
        ToggleModule,
        RouterLink,
        CommonModule,
        HrefComponent,
        ImageModule,
        GtmTrackNavigationClickDirective,
        ICmsClientModule
    ]
})
export class MeganavContentComponent extends UiComponent {
    @Input()
    tabIndex!: number;

    @Input()
    items!: NPageHeader.IMenuItem[];

    readonly toggleService = inject(ToggleService);

    readonly meganavToggleGroupId = NPageHeader.MEGANAV_GROUP_ID;

    get isCms(): boolean {
        return this.client.isCms && !this.client.isCmsPreview;
    }

    handleMouseEnter(index: number): void {
        this.toggleService.open([this.meganavToggleGroupId, index + this.tabIndex * 20]);
    }

    handleMouseLeave(index: number): void {
        if (!this.isCms) {
            this.toggleService.close([this.meganavToggleGroupId, index + this.tabIndex * 20]);
            this.items.forEach((menuItem, menuItemIndex) => {
                this.toggleService.close([this.meganavToggleGroupId, menuItemIndex + this.tabIndex * 20]);
            });
        }
    }
}
